import { connect } from "react-redux";

import WrappedSelect from "../shared_components/wrapped_select";

export default (action, title, valueSelector, optionsSelector, wdSelectProps, extraHtmlClasses) => {
  const clearable = !!wdSelectProps.clearable;

  const mapStateToProps = (state) => {
    const selectedValue = valueSelector(state);
    const values = optionsSelector(state);

    return { ...wdSelectProps, values, selectedValue, title, extraHtmlClasses };
  };

  const mapDispatchToProps = dispatch => ({
    onChange: (e) => {
      if (e && e.value) {
        dispatch(action(e));
      } else {
        // Only dispatch if the select has actually selected a value. Ignore blanks. UNLESS clearable is true.
        if (clearable) {
          dispatch(action(null));
        }
      }
    }
  });

  return connect(mapStateToProps, mapDispatchToProps)(WrappedSelect);
};
